import React from "react";
import { Link } from "react-router-dom";
import { Card, Container, Row, NavDropdown } from "react-bootstrap";
import CenteredLoadingIndicator from "../../sharedComponents/centeredLoadingIndicator";
import NoContent from "../../sharedComponents/noItemFoundAlert";
import { slice } from "lodash";
import "./home.scss";

export default function MyFitness({ myFitness }) {
	return (
		<Card className="my-fitness-card-container">
			<Card.Header className="card-header">
				<div>My Fitness</div>
				<div>
					<NavDropdown
						alignRight
						title={
							<span className="nav-icon">
								<i className={`icon icon-more`} />
							</span>
						}
						className="custom-dropdown"
						id="basic-nav-dropdown">
						<NavDropdown.Item href="/fitness/my-workout">Manage My Workout</NavDropdown.Item>
						<NavDropdown.Divider />
						<NavDropdown.Item href="/fitness/my-history">View My History</NavDropdown.Item>
						<NavDropdown.Divider />
						<NavDropdown.Item href="/fitness">My Fitness</NavDropdown.Item>
					</NavDropdown>
				</div>
			</Card.Header>
			<Card.Body>
				<Card.Title className="card-title">Exercises planned for today</Card.Title>
				{myFitness ? (
					myFitness.length ? (
						<Container className="content-container">
							{slice(myFitness, 0, 8).map((item, index) => (
								<Row key={index}>
									<p>
										{item.minutes} minutes •{" "}
										<Link
											className="text-primary-dark"
											to={`/fitness/exercises/${item.exercise.id}/details`}>
											{item.exercise.name}
										</Link>
									</p>
								</Row>
							))}
						</Container>
					) : (
						<NoContent />
					)
				) : (
					<CenteredLoadingIndicator />
				)}
			</Card.Body>
		</Card>
	);
}
